<section id="secao-titulo-apoio-cultural">
    <div class="container">
      <div class="imagem-apoio-cultural">
        <img
          src="assets/imagens/apoio-cultural.png"
          alt="imagem-apoio-cultural"
        />
      </div>
      <div class="titulo-apoio-cultural">
        <h2>Apoio Cultural</h2>
      </div>
    </div>
  </section>
  
